import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Login from './Login';
import UserManagement from './UserManagement';
import AdminManagement from './AdminManagement';
import ImagesPaymentsTable from './ImagesPaymentsTable';
import FinanceDashboard from './FinanceDashboard';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const navigate = useNavigate();

  // Check if user is already logged in (from localStorage)
  useEffect(() => {
    const savedRole = localStorage.getItem('userRole');
    const savedLocation = localStorage.getItem('adminLocation');
    
    if (savedRole) {
      // User was previously logged in 1
      setIsAuthenticated(true);
      setUserRole(savedRole);
      setCurrentUser({
        email: savedRole === 'superadmin' ? 'newsuperadmin@gmail.com' : '',
        role: savedRole,
        location: savedLocation || null
      });
    }
  }, []);

  const handleLogin = (user, role, location, telegramChatId) => {
    setCurrentUser({
      ...user,
      role,
      location,
      telegramChatId
    });
    setUserRole(role);
    setIsAuthenticated(true);
    navigate('/');
  };

  const handleLogout = () => {
    localStorage.removeItem('userRole');
    localStorage.removeItem('adminLocation');
    setIsAuthenticated(false);
    setCurrentUser(null);
    setUserRole(null);
    navigate('/login');
  };

  // If not authenticated, show login page for all routes
  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="*" element={<Login onLogin={handleLogin} />} />
      </Routes>
    );
  }

  // If authenticated, show main app with routes
  return (
    <Routes>
      <Route 
        path="/" 
        element={
          <ImagesPaymentsTable 
            adminLocation={currentUser?.location || localStorage.getItem('adminLocation')} 
            userRole={userRole || localStorage.getItem('userRole')}
            onLogout={handleLogout}
          />
        } 
      />
      <Route 
        path="/users" 
        element={
          <UserManagement 
            adminLocation={currentUser?.location || localStorage.getItem('adminLocation')} 
            onLogout={handleLogout}
            userRole={userRole || localStorage.getItem('userRole')}
          />
        } 
      />
      <Route 
        path="/admin" 
        element={
          userRole === 'superadmin' ? (
            <AdminManagement onBack={() => navigate('/')} />
          ) : (
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <h2>Ruxsat yo'q</h2>
              <p>Faqat superadmin bu sahifaga kirishi mumkin.</p>
              <button onClick={() => navigate('/')}>Orqaga</button>
            </div>
          )
        } 
      />
      <Route 
        path="/images" 
        element={
          <ImagesPaymentsTable 
            adminLocation={currentUser?.location || localStorage.getItem('adminLocation')} 
            userRole={userRole || localStorage.getItem('userRole')}
            onLogout={handleLogout}
          />
        } 
      />
      <Route
        path="/dashboard"
        element={<FinanceDashboard />}
      />
      <Route 
        path="/login" 
        element={<Login onLogin={handleLogin} />} 
      />
    </Routes>
  );
}

export default App;
